module.exports = __webpack_public_path__ + "fonts/notosans-bold-web.89f8492.ttf";